import { Injectable } from '@angular/core';

import { ApiService }           from '../api/api.service';
import { SpamEmailModel }       from './typings/security.spam-email';
import { TableQueryParameters } from '../table/types/table-query-parameters';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {
   public spamEmailsTableCacheKey  = 'blockedSpamEmails';

  constructor (
    private apiService: ApiService
  ) {}

  getSpamEmails ( params : TableQueryParameters = {} ) : Promise<Array<SpamEmailModel>> {
    return this.apiService
      .get('/workshop_admin/blocked_spam_emails', [
        params.offset    || 0,
        params.pageSize  || 10,
        params.field     || 'date',
        params.direction || 'desc'
      ]);
  }

  getSpamEmailsCount () : Promise<number> {
    return this.apiService.get('/workshop_admin/blocked_spam_emails_count');
  }

  overrideSpamEmail ( email : SpamEmailModel ) : Promise<any> {
    return this.apiService.patch(`/workshop_admin/override_spam_email/${ email.id }`);
  }

  setSpamBlocking ( enabled : boolean ) : Promise<any> {
    return this.apiService.patch('/workshop_admin/set_spam_blocking', { enabled });
  }
}
